import { DownloadUrl } from "./AppConfigs";

export const providerMaterialsHeaderLabel = ["Name", "Description", "Download"];

export const providerMaterialData = [
  {
    providerMaterialId: 1,
    name: "Prior Authorization Request / Referral Form - COLORADO / NEW MEXICO ONLY",
    description:
      "Colorado and New Mexico In-network Providers submit this form for an initial authorization request. Colorado and New Mexico Referring Providers submit this form to initiate home health services.",
    link: DownloadUrl.PRIOR_AUTHORIZATION_REQUEST,
  },
  {
    providerMaterialId: 2,
    name: "Referral Form - NEVADA ONLY",
    description:
      "Nevada Referring Providers submit this form to initiate home health services.",
    link: DownloadUrl.REFERRAL_FORM_NEVADA_ONLY,
  },
  {
    providerMaterialId: 3,
    name: "Centene-Ambetter PA-RA Request Form",
    description:
      "Arizona Standard Prior Authorization Request Form for health care.",
    link: DownloadUrl.CENTENE_AMBETTER_PA_PA_REQUEST_FORM,
  },
  {
    providerMaterialId: 4,
    name: "Resumption of Care Request Form",
    description:
      "A Resumption of Care (ROC) assessment is required any time the patient is admitted as an inpatient for 24 hours or more for other than diagnostic tests.",
    link: DownloadUrl.RESUMPTION_OF_CARE_REQUEST_FORM,
  },
  {
    providerMaterialId: 5,
    name: "Re-Authorization Request Form",
    description:
      "In-network providers submit this form for a re-authorization request, if needed.",
    link: DownloadUrl.RE_AUTHORIZATION_REQUEST_FORM,
  },
  {
    providerMaterialId: 6,
    name: "Start of Care Confirmation Form",
    description:
      "Form confirming start of care or resumption of care. Upload this form along with completed OASIS assessment.",
    link: DownloadUrl.START_OF_CARE_CONFIRMATION_FORM,
  },
  {
    providerMaterialId: 7,
    name: "Fax Confirmation Form",
    description:
      "Form to confirm fax numbers for authorization and re-authorization requests",
    link: DownloadUrl.FAX_CONFIRMATION_FORM,
  },
  {
    providerMaterialId: 8,
    name: "Out of Network Service Notification",
    description:
      "Out-of-network providers submit this form to receive payment for PPO members.",
    link: DownloadUrl.OUT_OF_NETWORK_SERVICE_NOTIFICATION,
  },
  {
    providerMaterialId: 9,
    name: "Electronic Funds Transfer (EFT) Enrollment",
    description: "Form to enroll in EFT payments. The tango payer ID is 26748",
    link: DownloadUrl.ELECTRONICS_FUNDS_TRANSFER_ENROLLMENT,
  },
  {
    providerMaterialId: 10,
    name: "Claims Dispute",
    description: "Form to dispute denial of a claim.",
    link: DownloadUrl.CLAIMS_DISPUTE,
  },
  {
    providerMaterialId: 11,
    name: "Information Change Form",
    description:
      "In-network providers submit this form to update agency information (TIN, NPI, address, etc.)",
    link: DownloadUrl.INFORMATION_CHANGE_FORM,
  },
  {
    providerMaterialId: 12,
    name: "Provider Manual",
    description: "Home Health Agency Provider Manual",
    link: DownloadUrl.PROVIDER_MANUAL,
  },
  {
    providerMaterialId: 13,
    name: "Managed Plan List",
    description: "Managed Health Plan List",
    link: DownloadUrl.MANAGED_HEALTH_PLAN_LIST,
  },
];
